var map = {
	"./benefit-icon_calendar.svg": "1976",
	"./benefit-icon_email.svg": "84b1",
	"./benefit-icon_football.svg": "c534",
	"./benefit-icon_list.svg": "d85d",
	"./benefit-icon_pen.svg": "b7d0",
	"./benefit-icon_people.svg": "79d5",
	"./benefit-icon_percentage.svg": "7ae2",
	"./benefit-icon_phone.svg": "4983",
	"./benefit-icon_ticket.svg": "e4c7",
	"./benefit-icon_unlock.svg": "766e",
	"./blue-triangle.svg": "b646",
	"./newBen-icon-food.svg": "eca1",
	"./newBen-icon-gift.svg": "09cd",
	"./newBen-icon-ticket.svg": "fcd3",
	"./orange-triangle.svg": "c15c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9cd0";